import { defineStore } from "pinia";

import { pathOr } from "ramda";

export const usePreflightDataStore = defineStore("preflightdata", {
  state: () => ({
    preflightData: {}
  }),

  getters: {
    getPreflightData(state) {
      return function (pp) {
        return pathOr({}, ["preflightData", pp], state);
      };
    }
  },

  actions: {
    setPreflightData(payload) {
      var preflightData = { ...this.preflightData };
      preflightData[payload.code] = payload.preflightData;
      this.preflightData = preflightData;
    },
    setPreflightCheckData(payload) {
      var filtered = {};
      for (var pp in payload) {
        filtered[pp] = {};
        for (var el in payload[pp]) {
          if (typeof payload[pp][el] == "object") {
            filtered[pp][el] = payload[pp][el];
          }
        }
      }
      var preflightData = { ...this.preflightData, ...filtered };
      this.preflightData = preflightData;
    },
    removePreflightDataPP(payload) {
      var newState = { ...this.preflightData };
      if (newState[payload]) {
        delete newState[payload];
        this.preflightData = newState;
      }
    }
  }
});
